import React, { Component } from 'react';
import { Container, Row, Col, Card, CardTitle, CardText } from 'reactstrap';

export default class ReportsList extends Component {
    constructor(props) {
        super(props);

        document.title = "Boards and Commissions Reports";
        this.state = { };
    }

    memberExpiration = () => {
        this.props.history.push('/admin/reports/membershipexpiration');
    }

    boardVacancy = () => {
        this.props.history.push('/admin/reports/boardvacancy');
    }

    render() {
        return (
            <div>
                <Container>
                    <Row className="justify-content-center">
                        <Col sm="6" className="d-flex align-items-stretch">
                            <Card
                                tag="a"
                                onClick={this.memberExpiration}
                                style={{ cursor: "pointer", textDecoration: "none" }}
                                body
                                outline
                                color="primary"
                                className="shadow"
                            >
                                <CardTitle><h4>Membership Expiration</h4></CardTitle>
                                <CardText>Displays a list of board members who have surpassed their expiration date</CardText>
                            </Card>
                        </Col>
                        <Col sm="6" className="d-flex align-items-stretch">
                            <Card
                                tag="a"
                                onClick={this.boardVacancy}
                                style={{ cursor: "pointer", textDecoration: "none" }}
                                body
                                outline
                                color="primary"
                                className="shadow"
                            >
                                <CardTitle><h4>Board Vacancy</h4></CardTitle>
                                <CardText>Displays number of vacant seats on each board</CardText>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}